import { render } from "./CloneSkeleton.vue?vue&type=template&id=3232a1e3&scoped=true"
import script from "./CloneSkeleton.vue?vue&type=script&lang=js"
export * from "./CloneSkeleton.vue?vue&type=script&lang=js"

import "./CloneSkeleton.vue?vue&type=style&index=0&id=3232a1e3&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3232a1e3"]])

export default __exports__